<template>
  <div class="search-filter" :class="{ 'full-search': showSearch }">
    <div class="left" v-if="enableLeft" v-show="!showSearch">
      <slot name="left">
        <div class="filter-campus" v-if="enableCampus" @click="clickCampusHandler">
          <span class="van-ellipsis">{{ campusText }}</span>
          <van-icon
            class="xiala"
            class-prefix="vxs-icon"
            name="system_choose"
            size="10"
            color="var(--g6)"
          />
        </div>
      </slot>
    </div>

    <div class="right" :class="{ 'full-width': !enableLeft || showSearch }" v-if="enablRight">
      <div class="filter-date" v-if="enableDate && !showSearch" @click="clickDateHandler">
        {{ startStr }}~{{ endStr }}
        <van-icon
          class="xiala"
          class-prefix="vxs-icon"
          name="system_choose"
          size="10"
          color="var(--g6)"
        />
      </div>

      <!-- 搜索栏 -->
      <form
        @submit.prevent="onsearch"
        class="search-box"
        :class="{ mr: !searchIcon }"
        v-show="showSearch || !searchIcon"
      >
        <!-- :show-action="searchIcon" -->
        <van-search
          class="search-input"
          v-model="keyword"
          shape="round"
          show-action
          :placeholder="placeholder"
          @search="onsearch"
          @clear="onsearch"
          @cancel="onCancel"
        >
          <template #action>
            <div @click="onsearch">搜索</div>
          </template>
          <template #left v-if="showSearch">
            <div class="cancelbtn" @click="onCancel">
              <van-icon name="arrow-left" size="18"/>
            </div>
          </template>
        </van-search>
      </form>

      <!-- 搜索图标 -->
      <div
        class="search-icon"
        v-if="enableSearch"
        v-show="!showSearch && searchIcon"
        @click="showSearchBox"
      >
        <svg class="vxm-icon" aria-hidden="true" font-size="24">
          <use xlink:href="#vxm-icon-sousuo"></use>
        </svg>
      </div>

      <!-- 筛选图标 -->
      <div class="fliter-icon" v-if="enableFilter" v-show="!showSearch" @click="emitClick">
        <van-icon
          class-prefix="vxs-icon"
          name="shaixuan1"
          size="24"
          :color="hasFilter ? 'var(--c1)' : 'var(--g8)'"
        ></van-icon>
        <!-- 配合主题色更改，去掉这个图标，换成统一的筛选未选中/已选中样式 -->
        <!-- <svg class="vxm-icon" aria-hidden="true" font-size="24">
          <use v-if="!hasFilter" xlink:href="#vxm-icon-screen-1"></use>
          <template v-else>
            <use v-if="scene == 'teacher'"
              xlink:href="#vxm-icon-shaixuandianliang"
            ></use>
            <use v-else-if="scene == 'parent'"
              xlink:href="#vxm-icon-screen-0"
            ></use>
          </template>
        </svg> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * 使用场景，区分是“老师端”还是“家长端”
     * teacher: 老师端
     * parent: 家长端
     */
    scene: {
      type: String,
      default: 'teacher',
    },
    // 是否开启左侧
    enableLeft: {
      type: Boolean,
      default: true,
    },
    // 是否开启校区筛选
    enableCampus: {
      type: Boolean,
      default: true,
    },
    // 传入选中的校区，供计算属性使用，以展示选中的校区文案
    campus: {},

    // 是否开启左侧
    enablRight: {
      type: Boolean,
      default: true,
    },

    // 是否开启日期筛选
    enableDate: {
      type: Boolean,
      default: true,
    },
    start: {
      type: String,
      default: '',
    },
    end: {
      type: String,
      default: '',
    },

    // 是否开启搜索
    enableSearch: {
      type: Boolean,
      default: true,
    },
    // 搜索初始化时，是否是图标展示
    searchIcon: {
      type: Boolean,
      default: true,
    },
    // 搜索框占位文本
    placeholder: {
      type: String,
      default: '请输入',
    },

    // 是否开启筛选
    enableFilter: {
      type: Boolean,
      default: true,
    },
    // 当前是否有筛选
    hasFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 是否展示搜索框
      showSearch: false,
      keyword: '',
    };
  },
  computed: {
    campusText: function () {
      if (Array.isArray(this.campus)) {
        if (this.campus.length == 0) {
          return '全部校区';
        } else if (this.campus.length == 1) {
          return this.campus[0].name;
        } else {
          return `${this.campus.length}个校区`;
        }
      } else if (typeof this.campus == 'object') {
        return this.campus.name;
      } else if (typeof this.campus == 'string') {
        return this.campus;
      } else {
        return '请传入选中校区';
      }
    },
    startStr: function () {
      return this.start.replace(/-/g, '.');
    },
    endStr: function () {
      return this.end.replace(/-/g, '.');
    },
  },
  methods: {
    onsearch(e, a) {
      this.$emit('search', this.keyword.trim());
    },
    showSearchBox() {
      this.showSearch = true;
    },
    onCancel() {
      this.showSearch = false;
      this.keyword = ''
      this.$emit('search', this.keyword.trim());
    },
    emitClick(e) {
      this.$emit('clickFilter');
    },
    // 选择校区
    clickCampusHandler() {
      this.$emit('clickCampus');
    },
    clickDateHandler() {
      this.$emit('clickDate');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-filter {
  position: relative;
  background: var(--white);
  height: 52px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    padding-left: calc(var(--gap) * 12);
    .filter-campus {
      flex: 1;
      display: flex;
      align-items: center;
      margin-right: calc(var(--gap) * 10);
      overflow: hidden;
    }
  }
  .right {
    padding-left: calc(var(--gap) * 12);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    &.full-width {
      width: 100%;
    }
    .search-box {
      flex: 1;
      &.mr {
        padding-right: calc(var(--gap) * 12);
      }
      .search-input {
        width: 100%;
        .cancelbtn {
          padding: calc(var(--gap) * 6) calc(var(--gap) * 8) calc(var(--gap) * 6) 0;
          height: 100%;
          color: var(--g8);
          display: flex;
          align-items: center;
        }
      }
    }
    .filter-date,
    .search-icon,
    .fliter-icon {
      padding-right: calc(var(--gap) * 12);
      height: 100%;
      display: flex;
      align-items: center;
    }
    .filter-date {
      flex: 1;
    }
  }
}

.search-input {
  &.van-search {
    padding-left: 0;
    padding-right: 0;
  }
}

.xiala {
  margin-left: calc(var(--gap) * 4);
}
</style>
